module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAZCAYAAAAxFw7TAAABD0lEQVQ4jb3VsUrDQBzA4YNWqoMoiijoLg5uPkkpuHbyBcSim30JHRz0FQQRQfsADoJu0lkcHFwUFR0+hyZQSpNe6+EPMoX7OJJ/LiEUhBpauNfrE7fYQbVoXRG2hkfFdTAfi82hW4LlXaMWA+5HYHmNUdgU3scAH0aB62NgeQtl4MYE4NK/7jDtM8zQdG85A2fFzeGNmDnse5ZfJdgLVmKgCvbwFrHDZzTLsBmcR0CDHaEybGeXE2B5x4Ng6w9Y3naOLeMjAfiE6YDdBFheI+gdlqk6CXhNCN4F/CQEuwFXCcGzgFW9v9lf62Cxf7DruDDe8fWdrakb/Fr6hryKTTRxgDZOs6uNw+zeliGnzS8wjLGDIMYchAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/Group 28.png
// module id = 0LiF
// module chunks = 1